import React, {ReactElement} from 'react';
import styled, {useTheme} from 'styled-components';
import {ForecastTheme} from '@forecast-it/design-system';
import {ForecastNavLogo} from '../../../../images/ForecastNavLogo';
import Logo, {LOGO_SIZE} from './Logo';

const NavLogoWrapper = styled.div<{$padding: string}>`
	display: flex;
	align-items: center;
	justify-content: center;

	padding: ${({$padding}) => $padding};
`;

const COMPACT_LOGO_MAX_WIDTH = '1143px';

const WideLogoWrapper = styled(NavLogoWrapper)`
	@media (max-width: ${COMPACT_LOGO_MAX_WIDTH}) {
		display: none;
	}
`;

const CompactLogoWrapper = styled(NavLogoWrapper)`
	display: none;

	@media (max-width: ${COMPACT_LOGO_MAX_WIDTH}) {
		display: flex;
	}
`;

const NavLogo = (): ReactElement => {
	const theme = useTheme();
	switch (theme.themeName) {
		case ForecastTheme.Sage:
			return (
				<NavLogoWrapper $padding="8px">
					<Logo size={LOGO_SIZE.SMALL} />
				</NavLogoWrapper>
			);
		default:
			return (
				<>
					<WideLogoWrapper $padding="16px 8px 4px">
						<ForecastNavLogo />
					</WideLogoWrapper>
					<CompactLogoWrapper $padding="8px">
						<Logo size={LOGO_SIZE.SMALL} />
					</CompactLogoWrapper>
				</>
			);
	}
};

export default NavLogo;
